import { createContext, useContext } from "react";

export interface IPayoutsContext {
  showCreateUpdatePayout: boolean;
  setShowCreateUpdatePayout: (val: boolean) => void;
  dataCreateUpdatePayout: any;
  setDataCreateUpdatePayout: (val: any) => void;
  convertCurrency: any;
  onGenerateCurrentState: () => void;
  paymentData: any;
}

export const PayoutsContext = createContext<IPayoutsContext>({
  showCreateUpdatePayout: false,
  setShowCreateUpdatePayout: () => {},
  dataCreateUpdatePayout: null,
  setDataCreateUpdatePayout: () => {},
  convertCurrency: {},
  onGenerateCurrentState: () => {},
  paymentData: null,
});

export const usePayoutsContext = () => useContext(PayoutsContext);
